module.exports = __webpack_public_path__ + "media/images/logo_openhouse-f5bf0010b4d3668bd76c6a8c977467ca.png";